const MONITOR_PHOTO_TYPES = ['CAMPAIGN_MONITOR_PHOTOS_UPDATED', 'CAMPAIGN_MONITOR_PHOTOS_DELETED'];

const getMonitorCategoryLabel = (
  notificationType: string,
  extraDetailsObj: Record<string, unknown> | undefined,
): string | undefined => {
  if (!MONITOR_PHOTO_TYPES.includes(notificationType)) return undefined;

  const rawCategory =
    notificationType === 'CAMPAIGN_MONITOR_PHOTOS_DELETED'
      ? ((extraDetailsObj?.category as string) ?? '')
      : ((extraDetailsObj?.uploadedPhotos as { category?: string }[])?.[0]?.category ?? '');

  return rawCategory
    .split('_')
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(' ');
};

export default getMonitorCategoryLabel;
